import { render } from "./InventoryHistory.vue?vue&type=template&id=b7ee095a&scoped=true"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"

import "./InventoryHistory.vue?vue&type=style&index=0&id=b7ee095a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ee095a"]])

export default __exports__